import { replace } from 'react-router-redux';
import { joinPath } from '@eventbrite/path-utils';
import { BASE_URL, PAY_IN_CONFIRMATION_PATH } from '../constants';

export const showPayInConfirmation = () => async (dispatch, getState) => {
    return dispatch(replace(joinPath(BASE_URL, PAY_IN_CONFIRMATION_PATH)));
};
